module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Hummer2-e8e844cd3ce92304270912c8321cd89a.svg";